import React from "react";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import OrderStatus from "@/enum/OrderStatus";
import { observer } from "mobx-react-lite";
import OrderItemStatusLabel from "../../../../../../../components/OrderItemImage/OrderItemStatusLabel";
import classnames from "classnames";
import { Tag } from "antd";

interface OrderItemDisplayNoPicProps {
    orderItem: OrderItemDTO;
    orderStatus: OrderStatus;
    showTitle: boolean;
    showSimpleTitle: boolean;
    showExternalId: boolean;
    showSkuProperties: boolean;
}

/**
 * 未勾选显示图片但是勾选了其他商品信息 则使用此组件
 */
const OrderItemDisplayNoPic: React.FC<OrderItemDisplayNoPicProps> = observer((props) => {
    const { orderItem, orderStatus, showTitle, showSimpleTitle, showExternalId, showSkuProperties } = props;

    const simpleTitle = orderItem.simpleTitle;
    const title = orderItem.title;
    const externalId = orderItem.skuExternalId || orderItem.productExternalId;
    const skuProperties = orderItem.localSkuProperties || orderItem.skuProperties;
    const isGift = orderItem.isGift;
    const totalElements: React.ReactNode[] = [];

    if (showTitle && showSimpleTitle) {
        if (simpleTitle) {
            totalElements.push(
                <span key="showTitleAndSimpleTitle" className="break-spaces">
                    {title}({simpleTitle})
                </span>,
            );
        } else {
            totalElements.push(<span key="showTitle">{title}</span>);
        }
    } else if (showTitle) {
        totalElements.push(
            <span key="showTitle" className="break-spaces">
                {title}
            </span>,
        );
    } else if (showSimpleTitle && simpleTitle) {
        totalElements.push(
            <span key="showSimpleTitle" className="break-spaces">
                {simpleTitle}
            </span>,
        );
    }

    if (showExternalId && externalId) {
        if (!totalElements.length) {
            totalElements.push(<span key="showExternalId">{externalId}</span>);
        } else {
            totalElements.push(<span key="showExternalId">&nbsp; {externalId}</span>);
        }
    }

    if (showSkuProperties && skuProperties) {
        if (!totalElements.length) {
            totalElements.push(
                <span key="showSkuProperties" className="break-spaces">
                    {skuProperties}
                </span>,
            );
        } else {
            totalElements.push(
                <span key="showSkuProperties" className="break-spaces">
                    &nbsp; {skuProperties}
                </span>,
            );
        }
    }

    totalElements.push(
        <span
            className={classnames(
                "mr10",
                orderItem.quantity >= 2 ? "high-light-order-item-quantity" : "order-item-quantity",
            )}
            key="quantity"
        >
            × {orderItem.quantity}
            {orderItem.canceledQuantity > 0 ? (
                <span className="text-danger font-bold fs11">（取消数量：{orderItem.canceledQuantity}）</span>
            ) : null}
            {isGift ? (
                <Tag variant="outlined" key="gift" color="volcano">
                    赠品
                </Tag>
            ) : null}
        </span>,
    );

    if (orderStatus !== orderItem.status) {
        totalElements.push(<OrderItemStatusLabel status={orderItem.status} key="orderItemStatusLabel" />);
    }

    return <p className="order-item-title">{totalElements}</p>;
});

export default OrderItemDisplayNoPic;
